import React, { useEffect, useState, useContext } from 'react';
import { jwtDecode } from 'jwt-decode';
import axios from 'axios';
import { AiOutlineLoading3Quarters } from "react-icons/ai";
import baseUrl from '../../components/baseUrl';
import Nav from '../../components/Nav/Nav';
import DashboardNav from '../../components/Nav/DashboardNav';
import Footer from '../../components/Footer/Footer';
import { useNavigate } from 'react-router-dom';
import blogImage1 from '../assets/Blog_image1.png';
import blogImage2 from '../assets/Blog_image2.jpg';
import blogImage3 from '../assets/Blog_image3.png';
import authorIcon from '../assets/author.svg'
import dateIcon from '../assets/date.svg'
import timeIcon from '../assets/time.svg'
import { useBlog } from '../../context/BlogContext';  // Ensure correct import
import { LOCAL_STORAGE_TOKEN_KEY } from '../../utils/constants';



const BlogPosts = () => {
    const [blogs, setBlogs] = useState([]);
    const [loading, setLoading] = useState(true);
    const [errorMessage, setErrorMessage] = useState("");
    const [user, setUser] = useState(null)

    const navigate = useNavigate();
    const blogContext = useContext(useBlog); // Safe context usage
    const setSelectedBlog = blogContext?.setSelectedBlog;  // Prevents destructuring error


    const blogImages = [blogImage3,blogImage2,blogImage1];


    const blogTags = [
        "Event Planning",
        "Event in Ghana",
        "Vendors in Ghana",
        "Vendors Options"
      ]; 
    //replace the above with the tags from the blog post

     // Decode the data 
     function decodeData(data) {
        return atob(data); // Base64 encoding
    }

    useEffect(() => {
        const storeToken = window.localStorage.getItem(LOCAL_STORAGE_TOKEN_KEY);
        // Decode the JWT token
        const decodedToken = storeToken ? decodeData(storeToken) : null;
        const userInfo = decodedToken ? jwtDecode(decodedToken) : null;
        if (userInfo) {
            setUser(userInfo?.user)
        }
    }, [setUser])

    useEffect(() => {
        const fetchBlogs = async () => {
            try {
                const response = await axios.get(`${baseUrl}/blogposts`);
                if (response.data.success) {
                    const blogsWithImages = response.data.data.map((blog, index) => ({
                        ...blog,
                        image: blogImages[index % blogImages.length]
                    }));
                    setBlogs(blogsWithImages);
                } else {
                    setErrorMessage("Failed to fetch blog posts.");
                }
            } catch (error) {
                setErrorMessage(error?.response?.data?.message || "Error fetching blog posts.");
            } finally {
                setLoading(false);
            }
        };

        fetchBlogs();
    }, []);

    // Function to create a slug from the blog title
    const createSlug = (title) => {
        return title.toLowerCase().replace(/ /g, '-').replace(/[^\w-]+/g, '');
    };

    // Function to check if the content contains HTML tags
    const hasHTMLTags = (content) => {
        const div = document.createElement("div");
        div.innerHTML = content;
        return div.innerHTML !== content; // If different, it contains HTML
    };

    const handleBlogClick = (blog) => {
        const slug = createSlug(blog.title);
        if (setSelectedBlog) {
            setSelectedBlog(blog); // Ensuring safe usage
        }
        navigate(`/blog/${slug}`);
    };



    return (
        <div>
            {user?
            <DashboardNav />:<Nav />}

            <div className='blog-container pt-[116px] sm:pt-[146px] lg:pt-[160px] px-6 md:px-8 xl:px-[102px] pb-[88px]'>
                <p className='text-ravdeepblue text-center font-black text-[24px]  leading-[30.2px] xl:text-[30px] xl:leading-[40.5px] mb-[34px]'>Blog Post</p>


                {loading && (
                    <div className="flex justify-center items-center">
                        <AiOutlineLoading3Quarters className="animate-spin text-4xl text-gray-500" />
                    </div>
                )}

                {errorMessage && (
                    <p className="text-red-500 text-center mt-4">{errorMessage}</p>
                )}

                <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-[97px] md:gap-4 xl:gap-8">
                    {blogs.slice(1).map((blog,index) => (
                        <div 
                            key={blog.id} 
                            className=" cursor-pointer "
                          
                        >                          
                           {/* <img src={blog.image || "https://via.placeholder.com/400"} alt={blog.title} className="w-full h-48 object-cover rounded-md" /> */}
                            <img src={blog.image} alt={blog.title} className="w-full h-56 xl:h-72 object-cover rounded-[20px]" />

                            <h2 className="text-sm font-black  mt-[9px]">{blog.title}</h2>

                            {/* Conditionally render HTML content or plain text */}
                            {/* {hasHTMLTags(blog.content) ? (
                                <div className="text-gray-600 mt-2" dangerouslySetInnerHTML={{ __html: blog.content.substring(0, 100) + "..." }} />
                            ) : (
                                <p className="text-gray-600 mt-2">{blog.excerpt || blog.content.substring(0, 100)}...</p>
                            )} */}

                           <div className='flex gap-3  mt-3'> 
                           <p className="flex items-center gap-1">
                                <img src={authorIcon} alt="Author Icon" className="" />
                                <span className="text-xs font-medium text-ravash">
                                    {/* {blog.author || "crownieeme"} */}
                                    {blog.title?.trim() === "Top Event Trends Taking Over Ghana in 2025" ? "velma nartey" : (blog.author || "crownie eme")}

                                </span>
                            </p> 
                            <p className="flex items-center gap-1">
                                <img src={dateIcon} alt="Date Icon" className="" />
                                <span className="text-xs font-medium text-ravash">
                                {new Date(blog.createdAt).toDateString()}
                                </span>
                            </p> 
                            <p className="flex items-center gap-1">
                                <img src={timeIcon} alt="Time Icon" className="" />
                                <span className="text-xs font-medium text-ravash">
                                3 min read
                                </span>
                            </p>                            
                           

                            </div>
                            <div className='mt-[18px] flex flex-wrap  gap-[10px]'>
                    
                                {blogTags.map((tag, index) => (
                                    <div className='text-ravash text-xs font-medium border border-ravgray h-[28px] p-3 items-center flex  rounded-[20px]  ' key={index}>
                                        {tag}
                                        </div>
                                ))}
                        

                            </div>

                            <button   onClick={() => handleBlogClick(blog)} type='Submit' className=' mt-6 w-[182px] h-[45px] mg:h-[50px] rounded-[80px] bg-[#0079FF] flex items-center justify-center text-center font-bold text-white text-[16px] leading-[21.6px]'>Read more</button>

                        </div>
                    ))}
                </div>
            </div>
            <Footer />
        </div>
    );
};

export default BlogPosts;



//WITHOUT THE HTML CHECK import React, { useEffect, useState } from 'react';
// import axios from 'axios';
// import { AiOutlineLoading3Quarters } from "react-icons/ai";
// import baseUrl from '../../components/baseUrl';
// import Nav from '../../components/Nav/Nav';
// import Footer from '../../components/Footer/Footer';
// import { useNavigate } from 'react-router-dom';
// import { useBlog } from '../../context/BlogContext';

// const BlogPosts = () => {
//     const [blogs, setBlogs] = useState([]);
//     const [loading, setLoading] = useState(true);
//     const [errorMessage, setErrorMessage] = useState("");

//     const navigate = useNavigate();
//     const { setSelectedBlog } = useBlog();  // Ensure this is inside BlogProvider

//     useEffect(() => {
//         const fetchBlogs = async () => {
//             try {
//                 const response = await axios.get(`${baseUrl}/blogposts`);
//                 if (response.data.success) {
//                     setBlogs(response.data.data);
//                 } else {
//                     setErrorMessage("Failed to fetch blog posts.");
//                 }
//             } catch (error) {
//                 setErrorMessage(error?.response?.data?.message || "Error fetching blog posts.");
//             } finally {
//                 setLoading(false);
//             }
//         };

//         fetchBlogs();
//     }, []);

// // Function to create a slug from the blog title
// const createSlug = (title) => {
//     return title.toLowerCase().replace(/ /g, '-').replace(/[^\w-]+/g, '');
// };


// const handleBlogClick = (blog) => {
//     const slug = createSlug(blog.title);
//     navigate(`/blog/${slug}`);
// };
//     return (
//         <div>
//             <Nav />
//             <div className='blog-container pt-[100px] sm:pt-[165px] px-6'>
//                 <h1 className='text-2xl font-bold text-center mb-6'>Latest Blog Posts</h1>

//                 {loading && (
//                     <div className="flex justify-center items-center">
//                         <AiOutlineLoading3Quarters className="animate-spin text-4xl text-gray-500" />
//                     </div>
//                 )}

//                 {errorMessage && (
//                     <p className="text-red-500 text-center mt-4">{errorMessage}</p>
//                 )}

//                 <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
//                     {blogs.map((blog) => (
//                         <div 
//                         key={blog.id} 
//                         className="blog-card p-4 border rounded-lg shadow-lg cursor-pointer hover:shadow-xl transition"
//                         onClick={() => handleBlogClick(blog)}
//                     >
                    
//                             <img src={blog.image || "https://via.placeholder.com/400"} alt={blog.title} className="w-full h-48 object-cover rounded-md" />
//                             <h2 className="text-lg font-bold mt-3">{blog.title}</h2>
//                             <p className="text-gray-600 mt-2">{blog.excerpt || blog.content.substring(0, 100)}...</p>
//                             <p className="text-sm text-gray-500 mt-2">By {blog.author || "Unknown"}</p>
//                         </div>
//                     ))}
//                 </div>
//             </div>
//             <Footer />
//         </div>
//     );
// };

// export default BlogPosts;
